import { createRouter, createWebHistory } from 'vue-router'
import Layout from '../layout/Layout.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/admin/Login.vue'),
    meta: { title: '登录', requiresAuth: false }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/admin/Dashboard.vue'),
        meta: { title: '控制台', icon: 'dashboard' }
      },
      {
        path: 'adConfig',
        name: 'AdConfig',
        component: () => import('../views/adConfig/AdConfigList.vue'),
        meta: { title: '广告配置', icon: 'fund' }
      },
      {
        path: 'user',
        name: 'User',
        component: () => import('../views/user/UserList.vue'),
        meta: { title: '用户管理', icon: 'user' }
      },
      {
        path: 'usageRecord',
        name: 'UsageRecord',
        component: () => import('../views/usageRecord/UsageRecordList.vue'),
        meta: { title: '使用记录', icon: 'schedule' }
      },
      {
        path: 'systemConfig',
        name: 'SystemConfig',
        component: () => import('../views/systemConfig/SystemConfig.vue'),
        meta: { title: '小程序设置', icon: 'setting' }
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('../views/admin/Profile.vue'),
        meta: { title: '个人设置', icon: 'setting' }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404'
  },
  {
    path: '/404',
    name: '404',
    component: () => import('../views/admin/404.vue'),
    meta: { title: '404', requiresAuth: false }
  }
]

const router = createRouter({
  history: createWebHistory('/vadmin/'),
  routes
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title ? `${to.meta.title} - 找厕所小程序管理系统` : '找厕所小程序管理系统'
  
  // 检查是否需要身份验证
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth !== false)
  const token = localStorage.getItem('token')
  const userInfo = localStorage.getItem('userInfo')
  
  if (requiresAuth && !token && !userInfo) {
    // 需要身份验证但未登录
    next('/login')
  } else if (to.path === '/login' && (token || userInfo)) {
    // 已登录用户尝试访问登录页，重定向到首页
    next('/')
  } else {
    next()
  }
})

export default router 